export default __webpack_public_path__ + "static/media/plus.f12d00b1.svg";